<script setup lang="ts">

import {computed} from "vue";

const props = defineProps({
  height: {
    type: Number,
    default: 41
  },

})

const height = computed(() => props.height)
const width = computed(() => props.height / 173 * 165)
</script>

<template>
  <svg :width="width" :height="height" viewBox="0 0 165 173"
       xml:space="preserve"  style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;">
    <g transform="matrix(1,0,0,1,-21.9316,-236.173)">
        <g transform="matrix(1,0,0,1,153,46)">
            <path d="M31.9,357.5C27.2,348 18.9,341 9.9,335.6C6.8,333.8 3.3,332.4 0.2,331.4C-6.9,329.1 -13.7,328.6 -21.7,327.2C-28.2,326.1 -33.3,323.4 -38.8,319.7C-41.6,317.7 -44,315.1 -45.9,312.2C-46.3,311.6 -48.1,309.4 -47.9,308.7C-47.9,308.7 -49.2,313.8 -46.7,320.9C-69.9,319.9 -90.2,307 -99.5,291.4C-116.6,262.7 -110.6,228 -87.8,212.6C-65,197.2 -30.1,208.1 -11.5,235.8C0.3,253.3 3.3,273.5 -1.7,290C-1.8,290.1 -1.8,290.3 -1.8,290.4C-11.7,283.2 -20.8,286.9 -20.8,286.9C-10.9,285.9 -3,293.8 -3,293.8C-1.8,294.8 -0.7,296 0.3,297.2C0.5,297.5 0.7,297.8 1,298.1C3.6,301.6 5.2,305.6 5.9,309.5C25.6,284.5 28.9,249.8 11.4,222.9C-10.8,188.6 -58.2,179.9 -94.4,203.3C-130.6,226.8 -141.9,273.6 -119.7,307.8C-101.4,336 -58.6,344.6 -34.1,336.8C-24.8,333.9 7,331.1 29.1,357.2C29.1,357.2 31,359.4 32.1,361.9C32.1,361.9 32.4,362.8 33.2,362.4C33.4,362.4 34,361.7 31.9,357.5M-13.6,311.2C-13.6,311.2 -13.7,311.2 -13.6,311.2C-13.7,311.2 -13.8,311.1 -13.8,311.1C-13.9,311.1 -13.9,311 -14,311L-14.1,311C-14.2,311 -14.3,311 -14.4,310.9C-15.4,310.7 -16.4,310.9 -17.3,311.4C-19.2,312.7 -19.5,315.7 -17.9,318C-17.2,319.1 -16.2,319.8 -15.1,320.2L-14.9,320.2C-14.9,320.2 -14.8,320.2 -14.8,320.3L-14.7,320.3C-14.6,320.3 -14.5,320.4 -14.4,320.4C-13.4,320.6 -12.4,320.5 -11.5,319.9C-9.6,318.6 -9.3,315.6 -10.8,313.3C-11.6,312.3 -12.5,311.6 -13.6,311.2M-0.8,305.8C-2.4,305.2 -2.6,307.1 -2.2,308.4C-1.3,311.3 -0.1,313.6 0.8,314C1.7,314.5 2.7,313.3 2,310.4C1.8,309.1 0.9,306.4 -0.8,305.8" style="fill:rgb(244,152,0);fill-rule:nonzero;"/>
        </g>
    </g>
</svg>

</template>

<style scoped lang="less">

</style>
